module.exports = __webpack_public_path__ + "public/Icons/logoutIcon.svg?66ba38d7";